export default __webpack_public_path__ + "static/media/success.0282704b.svg";